import { render } from "./InformeCumplimientoJuego.vue?vue&type=template&id=676d1dbb&scoped=true"
import script from "./InformeCumplimientoJuego.vue?vue&type=script&lang=js"
export * from "./InformeCumplimientoJuego.vue?vue&type=script&lang=js"

import "./InformeCumplimientoJuego.vue?vue&type=style&index=0&id=676d1dbb&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-676d1dbb"]])

export default __exports__